import {
  Button,
  Text,
  Portal,
  Menu,
  Slider,
  Stack,
  Box,
  Flex
} from '@chakra-ui/react'
import { useState, useCallback, useEffect } from 'react'
import { useRange, useCurrentRefinements, useClearRefinements } from 'react-instantsearch-hooks-web'

const RangeFilter = (props)=> {
  const {
    id,
    attribute,
    min,
    max,
    text,
    step,
    formatForTime = false
  } = props
  // Hard coding min to 0. Required for release_year to properly work. This is because not all songs have
  // release_year set so they default to 0. Min also NEEDS to be set because the filter doesn't work properly
  // without a min. Wonky behavior results without it.
  const { refine, start } = useRange({ attribute: attribute, max: max, min: 0 })
  const { items: currentRefinements } = useCurrentRefinements();
  const { refine: clearAllRefinements } = useClearRefinements({ includedAttributes: [attribute] });
  const isActiveRefinement = useCallback(
    (attribute) => {
      return !!currentRefinements.find((ref) => ref.attribute.includes(attribute));
    },
    [currentRefinements]
  );
  const [isOpen, setIsOpen] = useState(false)
  const [value, setValue] = useState([min, max])
  const active = isActiveRefinement(attribute) && (value[0] > min || value[1] < max);

  const handleRefine = (values)=>{
    if (values[0]===min && values[1]===max) refine([0, values[1]])
    else refine(values)
  }

  const formatTime = (time) => {
    // "<< 0" simply removes decimal values
    var minutes = (time / 1000 / 60) << 0,
      seconds = (time / 1000) % 60
      
    seconds = seconds.toFixed(0)
    if (seconds < 10) seconds = "0" + seconds
    if (minutes <= 0) minutes = ""
    return minutes + ":" + seconds
  }

  useEffect(()=> {
    setValue([Math.max(start[0], min), Math.min(start[1], max)])
  },[start, min, max])

  return(
    <Menu.Root id={attribute} autoSelect={false} closeOnSelect={false} onOpenChange={(details)=>setIsOpen(details.open)} isLazy>
      <Menu.Trigger
        outline="none"
        asChild>
        <Button
            display='flex'
            alignItems='center'
            textTransform='uppercase'
            backgroundColor={!isOpen ? "white" : "var(--purple)"}
            border={active || isOpen ? "solid 2px var(--purple)" : "solid 2px var(--light-purple)"}
            height="40px"
            borderRadius="20px"
            padding="0px 20px"
            variant="plain"
            color={!isOpen ? "var(--purple)" : "white" }
            _hover={{
              backgroundColor: "var(--purple)",
              color: 'white',
              borderColor: "var(--purple)"
            }}
            _active={{
              backgroundColor: "var(--purple)",
              color: 'white',
              borderColor: "var(--purple)"
            }}
            overflow='hidden'>
            <Text
              fontSize=".8rem"
              letterSpacing="0.128em"
              fontFamily='TTCommonsMedium'> 
              {text}
            </Text>
        </Button>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content
            shadow='lg'
            py='4'
            px='3'
            overflowY='auto'
            minW="max-content"
            maxH='25rem'
            //position='absolute'
            zIndex='999999999999999'
            borderRadius="20px"
            background="var(--light-purple)">
              <Menu.Item
                fontWeight='semibold'
                rounded='md'
                onClick={() => clearAllRefinements()}
                position='relative'
                cursor="pointer"
                color='gray.400'
                minH="13px"
                _hover={{
                  color: "var(--purple)"
                }}>
                <Text position='absolute' top='0px' right='0px' fontSize='0.6875rem'>
                  Reset
                </Text>
              </Menu.Item>
              <Stack alignItems='center' marginTop='1rem'>
                <Slider.Root 
                  width={{sm: "400px", base: "200px"}} 
                  defaultValue={[min, max]} 
                  value={value}
                  min={min}
                  max={max}
                  step={step}
                  onValueChange={(e)=>setValue(e.value)}
                  onValueChangeEnd={(e)=>handleRefine(e.value)}>
                  <Slider.Control>
                    <Slider.Track bg="white">
                      <Slider.Range bg="var(--purple)"/>
                    </Slider.Track>
                    <Slider.Thumbs borderColor='var(--purple)'/>
                  </Slider.Control>
                </Slider.Root>
                <Flex 
                  justifyContent='space-between' 
                  w='80%' 
                  alignItems='center' 
                  fontFamily='TTCOMMONSREGULAR'
                  color="var(--purple)"
                  marginTop='1.5rem'>
                  <Flex w='2.5rem' justifyContent='center'>
                    <Text>{formatForTime ? formatTime(value[0]) : value[0]}</Text>
                  </Flex>
                  <Box w="40px" h="0px" border="solid 1px var(--purple)"></Box>
                  <Flex w='2.5rem' justifyContent='center'>
                    <Text>{formatForTime ? formatTime(value[1]) : value[1]}</Text>
                  </Flex>
                </Flex>
                <Flex 
                  justifyContent='space-between' 
                  w='80%' 
                  alignItems='center' 
                  fontFamily='TTCOMMONSREGULAR'
                  color="var(--purple)">
                  <Flex w='2.5rem' justifyContent='center'>
                    <Text>min</Text>
                  </Flex>
                  <Flex w='2.5rem' justifyContent='center'>
                    <Text>max</Text>
                  </Flex>
                </Flex>
            </Stack>
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
      
    </Menu.Root>
  )
}

export default RangeFilter;